// Define a type for the event object
interface KeyboardEvent {
	ctrlKey: boolean;
	metaKey: boolean;
	shiftKey: boolean;
}

// Utility function to check if the Meta key is pressed
export const isMetaKey = (event: KeyboardEvent): boolean => {
	return event.metaKey;
};

// Utility function to check if the Ctrl key is pressed
export const isCtrlKey = (event: KeyboardEvent): boolean => {
	return event.ctrlKey;
};

// Utility function to check if the Ctrl or Meta key is pressed
export const isMetaOrCtrlKey = (event: KeyboardEvent): boolean => {
	return isMetaKey(event) || isCtrlKey(event);
};

// Utility function to check if the Shift key is pressed
export const isShiftKey = (event: KeyboardEvent): boolean => {
	return event.shiftKey;
};
